import { SessionActionTypes } from '../../../enums/ActionEnums';
import { isLoggedInUser } from '../../../util/SessionUtil';
const initialState = {
    shopId: null,
    market: null,
    firstName: '',
    lastName: '',
    deprecatedUser: false,
    uuid: null,
    amcUuid: null,
    username: null,
    authorities: [],
    enabled: true,
    isLoggedIn: false,
};
export const sessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SessionActionTypes.SET:
            return Object.assign(Object.assign({}, action.payload), { isLoggedIn: isLoggedInUser(action.payload) });
        case SessionActionTypes.LOGOUT:
            return Object.assign(Object.assign({}, state), { isLoggedIn: false });
        default:
            return state;
    }
};
